import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

type Options = Array<{
  icon: IconProp;
  title: string;
  details: string | string[];
}>;

export const EmptyStateCard = ({ options }: { options: Options }) => (
  <div className="flex flex-col gap-4 flex-grow">
    {options.map(({ title, icon, details }) => (
      <div key={title} className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon icon={icon} className="w-[20px]" />
          <Typography variant="body" size="large">
            {title}
          </Typography>
        </div>
        <div className="flex flex-col">
          {(Array.isArray(details) ? details : [details]).map((detail) => (
            <Typography
              key={detail}
              variant="body"
              size="medium"
              className={clsx('pl-7', sprinkles({ color: 'N-80' }))}
            >
              {detail}
            </Typography>
          ))}
        </div>
      </div>
    ))}
  </div>
);
